import { logout, useAppDispatch } from '@app';
import { useLogoutMutation } from '@features/authentication';
import { baseApi } from '@services';

export const useLogout = () => {
    const [doLogout, { isLoading }] = useLogoutMutation();
    const dispatch = useAppDispatch();

    async function handleLogout() {
        await doLogout();
        dispatch(baseApi.util.resetApiState());
        dispatch(logout());
    }

    return { handleLogout, isLoading };
};
